import { Component, forwardRef, OnInit, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { debounceTime, filter, switchMap } from 'rxjs/operators';
import english from '../../../../../main/maintenances/i18n/en.json';
import spanish from '../../../../../main/maintenances/i18n/es.json';
import portuguese from '../../../../../main/maintenances/i18n/pt.json';
import { LocationsApi } from '../../../../api/locations.api';
import { Location } from '../../../../interfaces';

export function ValidateAutocomplete(): object {
  return { required: true };
}

const INPUT_FIELD_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => LocationLegacyComponent),
  multi: true
};

@Component({
  selector: 'location-legacy',
  templateUrl: './location.component.html',
  styleUrls: ['./location.component.scss'],
  providers: [INPUT_FIELD_VALUE_ACCESSOR],
  encapsulation: ViewEncapsulation.None
})
export class LocationLegacyComponent implements ControlValueAccessor, OnInit {
  public locations = new Array<Location>();
  public inputValue = new FormControl();
  public hasSelectedLocation: boolean;
  public selectedLocation: Location;
  public loading = false;

  constructor(private fuseTranslationLoaderService: FuseTranslationLoaderService, private locationsApi: LocationsApi) {
    this.fuseTranslationLoaderService.loadJsonTranslations({english, portuguese, spanish});
  }

  ngOnInit(): void {
    this.inputValue.valueChanges
      .pipe(
        filter((searchTerm) => {
          return !!searchTerm;
        }),
        debounceTime(500),
        switchMap((searchTerm) => {
          this.loading = true;
          this.locations = [];
          return this.locationsApi.search(
            { formattedAddressOrDocumentNumber_contains: searchTerm, archived: false },
            {
              orderLegacy: false,
              orderColumn: 'formattedAddress',
              order: 'asc',
              offset: 0,
              operator: 'distance',
              value: searchTerm,
              limit: 10
            }
          );
        })
      )
      .subscribe((result) => {
        this.loading = false;
        this.locations = result.items;
      });
  }

  onChange: (_: any) => void = () => { };
  onTouched: (_: any) => void = () => { };

  writeValue(locationId: any): void {
    if (locationId) {
      this.locationsApi.searchOne(locationId).toPromise().then((location) => {
        this.selectedLocation = location;
        this.hasSelectedLocation = true;
        this.inputValue.setErrors(null);
      });
    } else {
      this.deselectLocation();
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setSelectedLocation(): void {
    if (this.inputValue.value) {
      this.onChange(this.inputValue.value);
      this.selectedLocation = this.locations.find((location) => location.id === this.inputValue.value) as Location;
      this.hasSelectedLocation = true;
      this.inputValue.setErrors(null);
    }
  }

  deselectLocation(): void {
    this.onChange(null);
    this.inputValue.setValue(null);
    this.selectedLocation = null;
    this.hasSelectedLocation = false;
    this.inputValue.setErrors(null);
  }
}
